import { fetchJson } from './asyncActionHelpers'
import { isValidGuid } from './actionUtil'

/* SHIPPING_METHOD */
export const SELECT_SHIPPING_METHOD          = 'SELECT_SHIPPING_METHOD_ACTION'
/* PAYMENT_METHOD */                         
export const SELECT_PAYMENT_OPTION           = 'SELECT_PAYMENT_OPTION_ACTION'
export const BRAINTREEE_PAYMENT_DATA_UPDATE = 'BRAINTREEE_PAYMENT_DATA_UPDATE_ACTION'
export const PURCHASE_ORDER_PAYMENT_DATA_UPDATE    = 'PURCHASE_ORDER_PAYMENT_DATA_UPDATE_ACTION'
/* COMPLETE CHECKOUT */                               
export const COMPLETE_CHECKOUT               = 'COMPLETE_CHECKOUT_ACTION'
export const PLACE_ORDER_ASYNC               = 'PLACE_ORDER_ASYNC_ACTION'
/* ERROR */                                  
export const NOTIFY_ERROR                    = 'NOTIFY_ERROR_ACTION'
export const NOTIFY_COMPLETE_CHECKOUT_ERROR  = 'NOTIFY_COMPLETE_CHECKOUT_ERROR_ACTION'
export const LOG_ERROR                       = 'LOG_ERROR_ACTION'
/* UI */                                     
export const USE_BILLING_FOR_SHIPPING_TOGGLE = 'USE_BILLING_FOR_SHIPPING_TOGGLE_ACTION'
export const DISMISS_MESSAGE                 = 'DISMISS_MESSAGE_ACTION'
/* CART */
export const UPDATE_ITEM_QUANTITY            = 'UPDATE_ITEM_QUANTITY'
export const DELETE_ITEM                     = 'DELETE_ITEM'
export const UPDATING_ITEM_QUANTITY_ASYNC    = 'UPDATING_ITEM_QUANTITY_ASYNC'
export const DELETING_ITEM_ASYNC             = 'DELETING_ITEM_ASYNC'

/* UI */

export function useBillingForShippingToggle() {
  return { type: USE_BILLING_FOR_SHIPPING_TOGGLE }
}

export function dismissMessage(messageId) {
  return {type: DISMISS_MESSAGE, messageId}
}

/* SHIPPING METHOD */

export function selectShippingMethod(shippingMethodId) {
  return { type: SELECT_SHIPPING_METHOD, shippingMethodId }
}

/* PAYMENT METHOD */

export function selectPaymentOption(paymentMethodId, displayName) {
  return { type: SELECT_PAYMENT_OPTION, paymentMethodId, displayName }
}

export function updateBraintreePaymentData(payload) {
  return { type: BRAINTREEE_PAYMENT_DATA_UPDATE, payload }
}

export function updatePurchaseOrderNumber(number) {
  return { type: PURCHASE_ORDER_PAYMENT_DATA_UPDATE, number }
}

/* CART */
export function updateItemQuantity(itemId, newQuantity) {
  return {type: UPDATE_ITEM_QUANTITY, itemId, newQuantity}
}

export function deleteItem(itemId) {
  return {type: DELETE_ITEM, itemId}
}

/* COMPLETE CHECKOUT */

export function completeCheckout() {
  return {type: COMPLETE_CHECKOUT}
}


/* ERROR */
let messageId = 0;

export function notifyError(message, diagnosticMessage) {
  diagnosticMessage && console.error(diagnosticMessage) && console.trace && console.trace();
  return { type: NOTIFY_ERROR, message, messageId: messageId++ }
}

export function notifyCompleteCheckoutError(message, diagnosticMessage) {
  diagnosticMessage && console.error(diagnosticMessage) && console.trace && console.trace();
  return { type: NOTIFY_COMPLETE_CHECKOUT_ERROR, message, messageId: messageId++ }
}

export function logError(diagnosticMessage) {
  diagnosticMessage && console.error(diagnosticMessage) && console.trace && console.trace();
  return {type: LOG_ERROR, diagnosticMessage}
}



/* ASYNC ACTION CREATORS */
const onPlaceOrderSuccess = (responseObject, { placeOrderDetails }, getState) => {
  if (responseObject.Success) {
    // No return, because we're navigating away from the app
    if (typeof window !== 'undefined' && window.location) {
      window.location.href = getState().constants.navigation.orderConfirmationUrl +"?orderNumber=" + responseObject.order.OrderNumber;
    }
    return null;
  } else {
    return notifyCompleteCheckoutError("We could not complete your checkout. " + responseObject.Message,
      JSON.stringify(responseObject));
  }
}

const completeCheckoutAsyncSpec = {
  endpoint: (state) => state.constants.navigation.placeOrderEndpoint,
  init: { method: 'POST', credentials: 'same-origin' },
  notify: ( placeOrderDetails ) => ({ type: PLACE_ORDER_ASYNC, placeOrderDetails }),
  extract: (response) => response.json(),
  onSuccess: onPlaceOrderSuccess,
  onError: (diagMsg) => notifyCompleteCheckoutError("An error occcurred placing your order", diagMsg)
}

export const completeCheckoutAsync = fetchJson(completeCheckoutAsyncSpec);


const onUpdateQuantitySuccess = ({ error, message }, { id, qty }, getState) => {
  if (!error) {
    return updateItemQuantity(id, qty);
  } else {
    return notifyError("Updating the quantity failed. Please try again or contact customer service.", message);
  }
}

const notifyUpdatingItem = function({ id, qty }) {
  return { type: UPDATING_ITEM_QUANTITY_ASYNC, id, qty };
}
const updateItemQuantityAsyncSpec = {
  endpoint: (state) => state.constants.navigation.updateItemQuantityEndpoint,
  init: { method: 'POST', credentials: 'same-origin' },
  notify: notifyUpdatingItem,
  extract: (response) => response.json(),
  onSuccess: onUpdateQuantitySuccess,
  onError: (diagMsg) => notifyError("An error occurred updating the quantity for your item", diagMsg)
}

export const updateItemQuantityAsync = fetchJson(updateItemQuantityAsyncSpec)


const ondeleteSuccess = ({ error, message }, { id }, getState) => {
  if (!error) {
    return deleteItem(id);
  } else {
    return notifyError("Deleting the item failed. Please try again or contact customer service.", message);
  }
}

const deleteItemAsyncSpec = {
  endpoint: (state) => state.constants.navigation.deleteItemEndpoint,
  init: { method: 'POST', credentials: 'same-origin' },
  notify: ({ id }) => ({ type: DELETING_ITEM_ASYNC, id }),
  extract: (response) => response.json(),
  onSuccess: ondeleteSuccess,
  onError: (diagMsg) => notifyError("An error occurred updating the for your item", diagMsg)
}

export const deleteItemAsync = fetchJson(deleteItemAsyncSpec)


// WEBPACK FOOTER //
// ./src/Components/checkout/actions/actions.js